<template>
  <div>
    <el-tabs v-model="TabName" type="border-card" @tab-click="ontabClick">
      <el-tab-pane label="Nomina" name="Nomina">
        <!--type="flex" justify="end"-->
        <el-row>
          <el-input v-model="NominaName" :disabled="true"> </el-input>
          <el-input v-model="NominaStatusName" :disabled="true"> </el-input>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="4">
            <!--
            <el-tooltip class="item" effect="light" content="Novedades Masivas" placement="top">
              -->

            <el-tooltip
              content="Nomina no puede ser editada despues de aprobada por RRHH"
              :disabled="this.nominaStatusApproved === 1"
              placement="bottom"
            >
              <el-dropdown trigger="click" @command="handledropdownNewsCommand">
                <el-button
                  type="info"
                  icon="el-icon-setting"
                  size="smalln"
                  :disabled="this.nominaStatusApproved !== 1"
                  >Novedades Masivas</el-button
                >
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="action in masiveDropdownActions"
                    :key="action.command"
                    :icon="action.icon"
                    :command="action.command"
                    divided
                    >{{ action.label }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-tooltip>
            <!--
            </el-tooltip>
            -->
          </el-col>
          <el-col :offset="1" :span="2">
            <!-- <el-tooltip class="item" effect="light" content="Estatus" placement="top"> -->

            <!-- <el-button :type="statusType">{{nominaStatus}}</el-button> -->
            <el-tag :type="typenominaOpenStatus">
              {{ labelnominaOpenStatus }}
            </el-tag>
            <!--
            <el-select
              v-model="nominaStatusSelected"
              placeholder="Estatus"
              size="small"
            >
              <el-option
                v-for="item in nominaStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            -->
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="2">
            <!-- <el-tooltip class="item" effect="light" content="Etapa" placement="top"> -->
            <!-- <el-tag :type="phaseType">{{nominaPhase}}</el-tag> -->
            <el-tag :type="typeNominaApprovalStatus">
              {{ labelNominaApprovalStatus }}
            </el-tag>
            <!--
            <el-select
              v-model="nominaPhaseSelected"
              placeholder="Etapa"
              size="small"
            >
              <el-option
                v-for="item in nominaPhases"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            -->
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :offset="1" :span="3">
            <!-- <el-tooltip class="item" effect="light" content="Año" placement="top"> -->
            <el-date-picker
              v-model="nominaYear"
              type="year"
              placeholder="Año"
              size="small"
            >
            </el-date-picker>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="3">
            <!-- <el-tooltip class="item" effect="light" content="Mes" placement="top"> -->
            <el-date-picker
              v-model="nominaMonth"
              type="month"
              placeholder="Mes"
              size="small"
              format="MMMM"
            >
            </el-date-picker>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="3">
            <!-- <el-tooltip class="item" effect="light" content="Quincena" placement="top"> -->
            <el-select
              v-model="biweeklySelected"
              placeholder="Quincena"
              size="small"
            >
              <el-option
                v-for="item in biweeklySelectItems"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="3">
            <el-select v-model="companyId" placeholder="Compañia" size="small">
              <el-option
                v-for="item in companySelected"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- <el-col :offset="1" :span="2">
            <el-tooltip class="item" effect="light" content="Recalcular Nomina" placement="top">
              <el-button type="info"  icon="el-icon-refresh" @click="RecalculateNomina(nominaId)"></el-button>
            </el-tooltip>
          </el-col> -->
          <el-col :offset="1" :span="3">
            <el-button
              type="info"
              icon="el-icon-plus"
              @click="GenerateNomina"
              size="small"
              >Generar Nomina</el-button
            >
          </el-col>
          <!-- <el-col :span="2" :offset="1">
            <el-button
              type="info"
              icon="el-icon-time"
              circle
              @click="OnHistoricClick"
            ></el-button>
          </el-col>
          <el-col :span="1">
            <el-dropdown trigger="click" @command="handledropdownCommand">
              <el-button icon="el-icon-setting"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="action in dropdownactions"
                  :key="action.command"
                  :icon="action.icon"
                  :command="action.command"
                  divided
                  >{{ action.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </el-col> -->
        </el-row>
        <el-row type="flex" justify="end">
          <el-col :span="5">
            <el-button
              type="success"
              plain
              round
              icon="el-icon-document"
              size="small"
              @click="exportToExcel"
            >
              Exportar a Excel
            </el-button>
          </el-col>
          <el-col
            v-if="
              IsInRoles([roles.Nomina_RH]) && this.nominaStatusApproved == 1
            "
            :span="6"
          >
            <el-button
              size="small"
              type="primary"
              @click="NominaApproved(1, nominaId)"
              >Aprobado recursos humanos</el-button
            >
          </el-col>
          <el-col
            v-if="
              IsInRoles([roles.Nomina_Finanzas]) &&
              this.nominaStatusApproved == 2
            "
            :span="5"
          >
            <el-button
              size="small"
              type="primary"
              @click="NominaApproved(2, nominaId)"
              >Aprobado finanzas</el-button
            >
          </el-col>
          <el-col
            v-if="
              IsInRoles([roles.Nomina_CEO]) && this.nominaStatusApproved == 3
            "
            :span="4"
          >
            <el-button
              size="small"
              type="success"
              @click="NominaApproved(3, nominaId)"
              >Aprobado ceo</el-button
            >
          </el-col>
          <el-col
            v-if="
              IsInRoles([
                roles.Nomina_RH,
                roles.Nomina_Finanzas,
                roles.Nomina_CEO
              ]) && this.nominaStatusApproved != 4
            "
            :span="4"
          >
            <el-button
              size="small"
              type="danger"
              @click="ManageDeclinedNomina(nominaId)"
              >Rechazar Nomina</el-button
            >
          </el-col>
          <el-col
            v-if="
              IsInRoles([
                roles.Nomina_RH,
                roles.Nomina_Finanzas,
                roles.Nomina_CEO
              ]) && this.nominaStatusApproved == 4
            "
            :span="4"
          >
            <el-button
              size="small"
              type="secondary"
              icon="el-icon-message"
              @click="SendPaymentSlip"
              >Enviar volantes de pago</el-button
            >
          </el-col>
          <el-col
            v-if="
              IsInRoles([
                roles.Nomina_RH,
                roles.Nomina_Finanzas,
                roles.Nomina_CEO
              ]) && this.nominaStatusApproved == 4
            "
            :span="4"
          >
            <el-button
              size="small"
              type="secondary"
              @click="GenerateTxtFile(nominaId, 'BHD')"
              >Generar TxT del BHD</el-button
            >
          </el-col>
          <el-col
            v-if="
              IsInRoles([
                roles.Nomina_RH,
                roles.Nomina_Finanzas,
                roles.Nomina_CEO
              ]) && this.nominaStatusApproved == 4
            "
            :span="4"
          >
            <el-button
              size="small"
              type="secondary"
              @click="GenerateTxtFile(nominaId, 'POPULAR')"
              >Generar TxT del Popular</el-button
            >
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="paymentForm"
              placeholder="Forma de Pago"
              size="small"
            >
              <el-option
                v-for="item in paymentForms"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3" :offset="1">
            <DirectionSelector
              @directionData="onDirectionDataLoad"
              @selection-change="OnDirectionSelected"
              size="small"
            />
          </el-col>
          <el-col :span="3" :offset="1">
            <EmployeeSelector
              :DireccionParams="DirectionSelected"
              placeholder="Empleados"
              @selection-change="OnEmployeeSelected"
              size="small"
            />
          </el-col>
        </el-row>
        <el-row>
          <MasiveIncomeDiscount
            v-if="TabName === 'Nomina'"
            :IncomesDiscountType="MasiveIncomesDiscountType"
            :NominaData="NominaData"
            :nominasData="nominaData"
            :isVisible="MasiveIncomeVisible"
            :Employee="Employee"
            :onlyEmployee="onlyEmployee"
            @Canceled="onCloseNominaGeneration"
            @ClosingMasiveIncomeDiscount="rechargeIncomeDiscountData"
          />
          <NominaHistoric
            ref="NominaHistoric"
            :NominahistoricIsVisible="NominahistoricIsVisible"
            @NominaLoaded="onNominaLoaded"
            :nominaStatusSelected="nominaStatusSelected"
            :nominaPhaseSelected="nominaPhaseSelected"
            :nominaYear="nominaYear"
            :nominaMonth="nominaMonth"
            :biweeklySelected="biweeklySelected"
            :DirectionSelected="DirectionSelected"
            :EmployeeSelected="EmployeeSelected"
            :companySeleted="companyId"
            :paymentForm="paymentForm"
            @NominaTitulo="nombreNomina"
            @EmployeeNomina="EmpleadoNomina"
            @OnHistoricClose="OnHistoricClose"
            @approval-status="(status) => (approvelStatus = status)"
          />
          <FormGenerateNomina
            :isVisible="nominaGenerateVisibility"
            :companySeleted="companyId"
            @NominaGeneration="GeneratingNomina"
            @onCloseNominaGeneration="onCloseNominaGeneration"
          />
          <IncomeDiscountToInsert
            :isVisible="IncomesDiscountVisibility"
            :IncomesDiscountType="IncomesDiscountType"
            @Canceled="onCloseNominaGeneration"
          />

          <ISRtopConfig
            :visibility="ISRtopConfigVisibility"
            @closingISRCOnfig="onCloseNominaGeneration"
          />
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Historial" name="History">
        <rabbey-table-3
          :data="historicData"
          :columns="historicColumns"
          :actions="HistoricActions"
          :loading="fetchingNominaData"
          @rtable-push-action="handledropdownCommand"
        />

        <el-dialog
          v-if="TabName === 'History'"
          :title="NominaData.Name"
          width="70%"
          :visible.sync="NominahistoricIsVisible"
          append-to-body
          @closed="OnHistoricClose"
        >
          <NominaHistoric
            :NominaDataInfo="NominaData"
            :inactivateActions="true"
            :NominaFrom="TabName"
          />
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="Historial de Ingresos" name="incomeHistoric">
        <el-row type="flex" justify="end">
          <!-- <el-button
            type="primary"
            icon="el-icon-plus"
            @click="openIncomeForm"
            circle
          ></el-button> -->
          <el-col :span="3">
            <el-select
              v-model="Incometypes"
              placeholder="Seleccione el tipo de ingresos"
              size="small"
              clearable
            >
              <el-option
                v-for="item in IncomesTypesoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3" :offset="1">
            <EmployeeSelector
              placeholder="Empleados"
              @selection-change="OnIcomesEmployeeSelected"
              size="small"
            />
          </el-col>
        </el-row>
        <rabbey-table-3
          :data="IcomesDataFiltered"
          :columns="IcomesColumns"
          :actions="Icomesactions"
          :loading="fetchingIcomesData"
          @rtable-push-action="handledropdownCommand"
        />
        <MasiveIncomeDiscount
          v-if="TabName === 'incomeHistoric'"
          :key="1"
          :isVisible="MasiveIncomeVisible"
          IncomesDiscountType="income"
          :NominaData="NominaData"
          :onlyEmployee="onlyEmployee"
          :isEdit="isEdit"
          @Canceled="onCloseNominaGeneration"
          @ClosingMasiveIncomeDiscount="rechargeIncomeDiscountData"
        />
      </el-tab-pane>
      <el-tab-pane label="Historial de Descuentos" name="discountHistoric">
        <el-row type="flex" justify="end">
          <!-- <el-button
            type="primary"
            icon="el-icon-plus"
            @click="openDiscountForm"
            circle
          ></el-button> -->
          <el-col :span="3">
            <el-select
              v-model="DiscountTypes"
              placeholder="Seleccione el tipo de descuentos"
              size="small"
              clearable
            >
              <el-option
                v-for="item in DiscountTypesoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3" :offset="1">
            <EmployeeSelector
              placeholder="Empleados"
              @selection-change="OnDiscountsEmployeeSelected"
              size="small"
            />
          </el-col>
        </el-row>
        <rabbey-table-3
          :data="DiscountsDataFiltered"
          :columns="DiscountsColumns"
          :actions="Discountsactions"
          :loading="fetchingDiscountsData"
          @rtable-push-action="handledropdownCommand"
        />
        <MasiveIncomeDiscount
          v-if="TabName === 'discountHistoric'"
          :key="2"
          :isVisible="MasivediscountVisible"
          IncomesDiscountType="discount"
          :NominaData="NominaData"
          :onlyEmployee="onlyEmployee"
          :isEdit="isEdit"
          @Canceled="onCloseNominaGeneration"
          @ClosingMasiveIncomeDiscount="rechargeIncomeDiscountData"
        />
      </el-tab-pane>
      <el-tab-pane label="Historial de CXC" name="cxcHistoric">
        <CXC :isView="true" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import FormGenerateNomina from "@/views/apps/employees/Nomina/Form Nomina/FormGenerateNomina.vue";
import IncomeDiscountToInsert from "@/views/apps/employees/Nomina/Form Nomina/IncomeDiscountToInsert.vue";
import MasiveIncomeDiscount from "@/views/apps/employees/Nomina/Form Nomina/MasiveIncomeDiscount.vue";
import ISRtopConfig from "@/views/apps/employees/Nomina/NominaConfig/ISRtopConfig.vue";
import NominaHistoric from "@/views/apps/employees/Nomina/Historic/NominaHistoric.vue";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import { formatMonto } from "@/utils";
import nominacolorBoolTag from "@/components/Nomina/nominacolorBoolTag.vue";
import CXC from "@/views/apps/employees/profiles/CXCemployees/CXC.vue";
import {
  IncomesColumns,
  IncomesActions
} from "@/views/apps/employees/Nomina/Columns and actions/IncomesColumnsAndActions.js";
import {
  DiscountsColumns,
  DiscountsActions
} from "@/views/apps/employees/Nomina/Columns and actions/DiscountsColumnsAndActions.js";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
import { exportNominaToExcel } from "@/helpers/exportExcel";
import { FormatCedula } from "@/utils";

export default {
  name: "Nomina",
  components: {
    FormGenerateNomina,
    IncomeDiscountToInsert,
    MasiveIncomeDiscount,
    ISRtopConfig,
    NominaHistoric,
    CXC,
    DirectionSelector,
    EmployeeSelector
  },
  data() {
    return {
      TabName: "Nomina",
      NominaData: {},
      nominaTitle: "",
      statusType: "",
      nominaStatusSelected: true,
      nominaPhaseSelected: "",
      nominaYear: new Date(),
      nominaMonth: new Date(),
      biweeklySelected: 1,
      onlyEmployee: false,
      isEdit: false,
      Employee: [],
      DirectionSelected: 0,
      EmployeeSelected: 0,
      Directions: [],
      paymentForm: 0,
      approvelStatus: "",
      paymentForms: [
        {
          value: 0,
          label: "Todos"
        },
        {
          value: 1,
          label: "Cheque"
        },
        {
          value: 2,
          label: "Efectivo"
        },
        {
          value: 3,
          label: "Banco"
        }
      ],

      Incometypes: "",
      IncomesTypesoptions: [
        {
          value: "Commision",
          label: "Comision"
        },
        {
          value: "Incentive",
          label: "Incentivos"
        },
        /*
        {
          value: "VacationalBonus",
          label: "Prima Vacacional"
        },
        */
        {
          value: "Salario_rectro",
          label: "Salario Rectroactivo"
        },
        {
          value: "DTrabajado",
          label: "Dias Trabajados"
        },
        {
          value: "Annual_Bonus",
          label: "Bonificacion Anual"
        },
        {
          value: "Other_Incomes",
          label: "Otros Ingresos"
        }
      ],
      DiscountTypes: "",
      DiscountTypesoptions: [
        {
          value: "DescEsp",
          label: "Descuentos Especiales"
        },
        {
          value: "INFOTEP",
          label: "Infotep"
        },
        {
          value: "Other_Disc",
          label: "Otros Descuentos"
        }
      ],
      nominaStatus: [
        {
          value: true,
          label: "Abierta"
        },
        {
          value: false,
          label: "Cerrada"
        }
      ],
      phaseType: "",
      nominaPhases: [
        {
          value: 1,
          label: "Sin Aprovar"
        },
        {
          value: 2,
          label: "Aprobado por recursos humanos"
        },
        {
          value: 3,
          label: "Aprobado por finanzas"
        },
        {
          value: 4,
          label: "Aprobado por CEO"
        }
      ],
      actions: [
        {
          command: "apply-income",
          label: "Aplicar Ingreso",
          Icon: ""
        },
        {
          command: "apply-discount",
          label: "Aplicar Descuento",
          Icon: ""
        }
      ],
      biweeklySelectItems: [
        {
          value: 1,
          label: "1ra quincena"
        },
        {
          value: 2,
          label: "2da quincena"
        }
      ],
      companySelected: [
        {
          value: "TB",
          label: "Tennos Business",
          rnc: "131844804"
        },
        {
          value: "RB",
          label: "Rabbey Technology",
          rnc: "131849857"
        },
        {
          value: "MTR",
          label: "MagyTrack",
          rnc: "131843982"
        },
        {
          value: "VF",
          label: "VENTAFIEL TECHNOLOGIES",
          rnc: "131843982"
        }
        /*
        {
          value: "MGPSLA",
          label: "Magycorp SRL"
        },
        {
          value: "MGPTSA",
          label: "Magycorp SA"
        },
        {
          value: "MGPTT",
          label: "Magycorp Technologies"
        }*/
      ],
      companyId: "TB",
      nominaGenerateVisibility: false,
      IncomesDiscountVisibility: false,
      IncomesDiscountType: "",
      MasiveIncomeVisible: false,
      MasivediscountVisible: false,
      MasiveIncomesDiscountType: "",
      NominahistoricIsVisible: false,
      fetchingNominaData: false,
      fetchingIcomesData: false,
      fetchingDiscountsData: false,
      IcomesData: [],
      IcomesColumns: IncomesColumns,
      Icomesactions: IncomesActions,
      DiscountsData: [],
      DiscountsColumns: DiscountsColumns,
      Discountsactions: DiscountsActions,
      historicData: [],
      nominaData: [],
      NominaName: "",
      nominaId: 0,
      nominaStatusApproved: 0,
      nominaOpenStatus: Boolean,
      NominaStatusName: "",
      arrayOfSummariesToExport: [],
      arrayOfNominasProps: [
        "Salario",
        "SalarioQuincenal",
        "diasTrabajados",
        "MontoTrabajado",
        "Comision",
        "OtrosIngresos",
        "Incetivos",
        "Vacaciones",
        "SalarioRetroactivo",
        "total_income",
        "Total_AFP",
        "Total_SFS",
        "PERCAPITA",
        "PrivateInsurance",
        "ISR_COBRADO",
        "CXC",
        "OtrosDescuentos",
        "DESCUENTOS_ESPECIALES",
        "total_discount",
        "TOTAL_A_PAGAR"
      ],
      historicColumns: [
        {
          prop: "Id",
          label: "No. Nomina",
          "min-width": 100,
          align: "center"
        },
        {
          prop: "Name",
          label: "Nomina",
          "min-width": 200
        },
        {
          prop: "CreatedAt",
          label: "Fecha de Creacion",
          "min-width": 150,
          formatter: CellDateTime
        },
        {
          prop: "CreateBy",
          label: "Creada por",
          "min-width": 100
        },
        {
          prop: "Desde",
          label: "Inicio de Nomina",
          "min-width": 130,
          formatter: CellDateTime
        },
        {
          prop: "Hasta",
          label: "Fin de Nomina",
          "min-width": 130,
          formatter: CellDateTime
        },
        {
          prop: "Aprobed",
          label: "Aprobada?",
          "min-width": 100,
          align: "center",
          formatter: nominacolorBoolTag
        },
        {
          prop: "Open",
          label: "Abierta?",
          "min-width": 100,
          align: "center",
          formatter: nominacolorBoolTag
        },
        {
          prop: "ClosedAt",
          label: "Fecha de Cierre",
          "min-width": 130,
          formatter: CellDateTime
        },
        {
          prop: "TotalHoraExtra",
          label: "Horas Extras",
          "min-width": 130,
          formatter: (row) => formatMonto(row.TotalHoraExtra)
        },
        {
          prop: "TotalAFP",
          label: "AFP",
          "min-width": 130,
          formatter: (row) => formatMonto(row.TotalAFP)
        },
        {
          prop: "TotalSFS",
          label: "SFS",
          "min-width": 130,
          formatter: (row) => formatMonto(row.TotalSFS)
        },
        {
          prop: "TotalISR",
          label: "ISR",
          "min-width": 130,
          formatter: (row) => formatMonto(row.TotalISR)
        },
        {
          prop: "TotalAmount",
          label: "Monto Total",
          "min-width": 130,
          formatter: (row) => formatMonto(row.TotalAmount)
        },
        {
          prop: "approvalstatus",
          label: "Estatus aprobacion",
          "min-width": 130
        }
      ],
      masiveDropdownActions: [
        {
          command: "apply-income",
          label: "Aplicar Ingreso Masivo",
          icon: "el-icon-sort-up"
        },
        {
          command: "apply-discount",
          label: "Aplicar Descuento Masivo",
          icon: "el-icon-sort-down"
        }
      ],
      HistoricActions: [
        {
          command: "Nomina-details",
          label: "Ver detalles de Nomina",
          icon: "el-icon-view"
        }
      ],
      dropdownactions: [
        {
          command: "Nomina-details",
          label: "Ver detalles de Nomina",
          icon: "el-icon-view"
        },
        {
          command: "recalculate_Nomina",
          label: "Recalcular nomina",
          icon: "el-icon-sort-up"
        },
        /*
        {
          command: "apply-income",
          label: "Aplicar Ingreso Masivo",
          icon: "el-icon-sort-up"
        },
        {
          command: "apply-discount",
          label: "Aplicar Descuento Masivo",
          icon: "el-icon-sort-down"
        },
        */
        {
          command: "approved-by-RR.HH.",
          label: "Aprobado por recursos humanos",
          icon: "el-icon-user",
          condition: (row) => {
            return (
              row.approvalstatus == 1 && this.IsInRoles([this.roles.Nomina_RH])
            );
          }
        },
        {
          command: "approved-by-finance",
          label: "Aprobado por finanzas",
          icon: "el-icon-money",
          condition: (row) => {
            return (
              row.approvalstatus == 2 &&
              this.IsInRoles([this.roles.Nomina_Finanzas])
            );
          }
        },
        {
          command: "approved-by-ceo",
          label: "Aprobado por CEO",
          icon: "el-icon-check",
          condition: (row) => {
            return (
              row.approvalstatus == 3 && this.IsInRoles([this.roles.Nomina_CEO])
            );
          }
        },
        {
          command: "refuse-payroll",
          label: "Rechazar nomina",
          icon: "el-icon-close",
          condition: (row) => {
            return (
              row.approvalstatus != 4 &&
              this.IsInRoles([
                this.roles.Nomina_RH,
                this.roles.Nomina_Finanzas,
                this.roles.Nomina_CEO
              ])
            );
          }
        },
        {
          command: "generate-txt",
          label: "Generar nomina txt",
          icon: "el-icon-document",
          condition: (row) => {
            return (
              row.approvalstatus == 4 &&
              this.IsInRoles([
                this.roles.Nomina_RH,
                this.roles.Nomina_Finanzas,
                this.roles.Nomina_CEO
              ])
            );
          }
        }
        /*,
        {
          command: "set-ISR-top",
          label: "Configurar tope de ISR",
          icon: ""
        }
        */
      ],
      ISRtopConfigVisibility: false
    };
  },
  mounted() {
    // this.GetNominaReport();
    // this.GetIncomeData();
    // this.GetDiscountData();
  },
  computed: {
    /*
    nominaId() {

      return this.nominaData[0].NominaId;
    },
    */
    /*
    NominaName() {
      let name = this.nominaData[0].Nomina.Name ;
      return name;
    }
    */
    /*
    NominaDataFiltered() {

      let nomina
      if (this.DirectionSelected !== ""){
        nomina = this.NominaData
      }
      nomina = this.NominaData
      return nomina
    }
    */
    labelnominaOpenStatus() {
      let status = "";
      switch (this.nominaOpenStatus) {
        case true: {
          status = "Abierta";
          break;
        }
        case false: {
          status = "Cerrada";
          break;
        }
      }
      return status;
    },
    typenominaOpenStatus() {
      let type = "";
      switch (this.nominaOpenStatus) {
        case true: {
          type = "success";
          break;
        }
        case false: {
          type = "danger";
          break;
        }
      }
      return type;
    },
    labelNominaApprovalStatus() {
      let ApproveStatus = "";
      switch (this.nominaStatusApproved) {
        case 1:
          ApproveStatus = "En RRHH";
          break;
        case 2:
          ApproveStatus = "En Finanzas";
          break;
        case 3:
          ApproveStatus = "En CEO";
          break;
        case 4:
          ApproveStatus = "Aprovada";
          break;
      }
      return ApproveStatus;
    },
    typeNominaApprovalStatus() {
      let TypeApproveStatus = "";
      switch (this.nominaStatusApproved) {
        case 1:
          TypeApproveStatus = "danger";
          break;
        case 2:
          TypeApproveStatus = "warning";
          break;
        case 3:
          TypeApproveStatus = "primary";
          break;
        case 4:
          TypeApproveStatus = "success";
          break;
      }
      return TypeApproveStatus;
    },
    labelApprovalStatus() {
      let ApproveStatus = "";
      switch (this.nominaStatusApproved) {
        case 1:
          ApproveStatus = "Debe ser aprobado por recursos humanos";
          break;
        case 2:
          ApproveStatus = "Debe ser aprobado por finanzas";
          break;
        case 3:
          ApproveStatus = "Debe ser aprobado por CEO";
          break;
        case 4:
          ApproveStatus = "Completamente aprobado";
          break;
      }
      return ApproveStatus;
    },
    IcomesDataFiltered() {
      let IcomeDataFiltered = this.IcomesData;
      if (this.Incometypes !== "" && this.EmployeeSelected !== 0) {
        IcomeDataFiltered = this.IcomesData.filter(
          (income) =>
            income.income_Type === this.Incometypes &&
            income.employee_Id === this.EmployeeSelected
        );
      } else if (this.Incometypes !== "") {
        IcomeDataFiltered = this.IcomesData.filter(
          (income) => income.income_Type === this.Incometypes
        );
      } else if (this.EmployeeSelected !== 0) {
        IcomeDataFiltered = this.IcomesData.filter(
          (income) => income.employee_Id === this.EmployeeSelected
        );
      }

      return IcomeDataFiltered;
    },
    DiscountsDataFiltered() {
      let DiscountDataFiltered = this.DiscountsData;
      if (this.DiscountTypes !== "" && this.EmployeeSelected !== 0) {
        DiscountDataFiltered = this.DiscountsData.filter(
          (discount) =>
            discount.discount_Type === this.DiscountTypes &&
            discount.employee_Id === this.EmployeeSelected
        );
      } else if (this.DiscountTypes !== "") {
        DiscountDataFiltered = this.DiscountsData.filter(
          (discount) => discount.discount_Type === this.DiscountTypes
        );
      } else if (this.EmployeeSelected !== 0) {
        DiscountDataFiltered = this.DiscountsData.filter(
          (discount) => discount.employee_Id === this.EmployeeSelected
        );
      }

      return DiscountDataFiltered;
    }
  },
  methods: {
    nombreNomina(datos) {
      this.nominaTitle = datos;
    },
    EmpleadoNomina(datos) {
      const { command, row } = datos;
      this.Employee = [];
      this.onlyEmployee = true;
      this.Employee.push(row.Empleado);

      switch (command) {
        case "apply-income": {
          this.MasiveIncomesDiscountType = "income";
          this.MasiveIncomeVisible = true;
          break;
        }
        case "apply-discount": {
          this.MasiveIncomesDiscountType = "discount";
          this.MasiveIncomeVisible = true;
          break;
        }
      }
    },
    GetNominaReport() {
      this.fetchingNominaData = true;
      this.$http
        .get("/api/Payroll/GetNominaList")
        .then((resp) => {
          this.$refs.NominaHistoric.GetNominaItems();
          this.approvelStatus = resp.data.approvalstatus;
          this.historicData = resp.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.fetchingNominaData = false;
        });
    },
    GenerateNomina() {
      this.nominaGenerateVisibility = true;
    },
    RecalculateNomina(nomina) {
      this.$http
        .get("/api/Payroll/RecalcularNomina", {
          params: {
            NominaID: nomina.Id,
            Biweekly: nomina.Biweekly,
            fromDate: nomina.Desde,
            toDate: nomina.Hasta,
            NominaName: nomina.Name,
            companyID: this.companyId,
            User: this.currentUser.UserID,
            isNew: false
          }
        })
        .then((resp) => {
          resp;
          //this.NominaData = resp.data
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.GetNominaReport();
        });
    },
    onCloseNominaGeneration() {
      this.nominaGenerateVisibility = false;
      this.IncomesDiscountVisibility = false;
      this.MasiveIncomeVisible = false;
      this.MasivediscountVisible = false;
      this.ISRtopConfigVisibility = false;
    },
    GeneratingNomina() {
      this.$refs.NominaHistoric.GetNominaItems();
      this.GetNominaReport();

      this.nominaGenerateVisibility = false;
    },
    handleCommand(action) {
      switch (action.command) {
        case "apply-income": {
          this.IncomesDiscountType = "income";
          this.IncomesDiscountVisibility = true;

          break;
        }
        case "apply-discount": {
          this.IncomesDiscountType = "discount";
          this.IncomesDiscountVisibility = true;
          break;
        }
      }
    },
    conditionalActions: () => true,
    /*
    PostIncomeToInsert() {
      this.$http.post("/api/Payroll/insertIcomes");
    },
    */
    async handledropdownCommand(action) {
      this.NominaData = action.row;
      switch (action.command) {
        case "Nomina-details": {
          this.NominahistoricIsVisible = true;
          break;
        }
        case "apply-income": {
          this.MasiveIncomesDiscountType = "income";
          this.MasiveIncomeVisible = true;
          break;
        }
        case "apply-discount": {
          this.MasiveIncomesDiscountType = "discount";
          this.MasiveIncomeVisible = true;
          break;
        }
        case "recalculate_Nomina": {
          this.RecalculateNomina(action.row.Id);
          break;
        }
        case "set-ISR-top": {
          this.ISRtopConfigVisibility = true;
          break;
        }
        case "approved-by-RR.HH.": {
          await this.NominaApproved(
            this.NominaData.approvalstatus,
            this.NominaData.Id
          );
          this.GetNominaReport();
          break;
        }
        case "approved-by-finance": {
          await this.NominaApproved(
            this.NominaData.approvalstatus,
            this.NominaData.Id
          );
          this.GetNominaReport();
          break;
        }
        case "approved-by-ceo": {
          await this.NominaApproved(
            this.NominaData.approvalstatus,
            this.NominaData.Id
          );
          this.GetNominaReport();
          break;
        }
        case "refuse-payroll": {
          await this.ManageDeclinedNomina(this.NominaData.Id);
          this.GetNominaReport();
          break;
        }
        case "generate-txt": {
          await this.GenerateTxtFile(this.NominaData.Id);
          this.GetNominaReport();
          break;
        }
        case "delete_income": {
          this.DeleteIncome(action.row);
          break;
        }
        case "edit_income": {
          this.isEdit = true;
          this.onlyEmployee = true;
          this.MasiveIncomeVisible = true;
          break;
        }
        case "edit_discount": {
          this.isEdit = true;
          this.onlyEmployee = true;
          this.MasivediscountVisible = true;
          break;
        }
        case "delete_discount": {
          this.DeleteDiscount(action.row);
          break;
        }
      }
    },
    handledropdownNewsCommand(action) {
      switch (action) {
        case "apply-income": {
          this.onlyEmployee = false;
          this.MasiveIncomesDiscountType = "income";
          this.MasiveIncomeVisible = true;
          break;
        }
        case "apply-discount": {
          this.onlyEmployee = false;
          this.MasiveIncomesDiscountType = "discount";
          this.MasiveIncomeVisible = true;
          break;
        }
      }
    },
    async GetIncomeData() {
      this.fetchingIcomesData = true;
      await this.$http.get("/api/Payroll/GetIncomes").then((resp) => {
        this.IcomesData = resp.data;
      });
      this.fetchingIcomesData = false;
    },
    async GetDiscountData() {
      this.fetchingDiscountsData = true;
      await this.$http.get("/api/Payroll/GetDiscounts").then((resp) => {
        this.DiscountsData = resp.data;
      });
      this.fetchingDiscountsData = false;
    },
    openIncomeForm() {
      this.MasiveIncomeVisible = true;
    },
    openDiscountForm() {
      this.MasivediscountVisible = true;
    },
    OnHistoricClick() {
      this.NominahistoricIsVisible = true;
    },
    onNominaLoaded(nominaData) {
      if (nominaData.length > 0) {
        this.nominaData = nominaData;
        this.NominaName = nominaData[0].Nomina.Name;
        this.nominaId = nominaData[0].Nomina.Id;
        this.nominaStatusApproved = nominaData[0].Nomina.approvalstatus;
        this.nominaOpenStatus = nominaData[0].Nomina.Open;
      } else {
        this.NominaName = "Esta Nomina no ha sido Generada";
      }
    },
    OnHistoricClose() {
      this.NominahistoricIsVisible = false;
    },
    async NominaApproved(status, NominaId) {
      const params = {
        status: status,
        NominaId: NominaId
      };
      await this.$http
        .put("/api/Payroll/updatestatusnomina", params)
        .then(() => {
          this.$message.success("Estatus actualizado");
          this.nominaStatusApproved = status + 1;
        })
        .catch(() => {
          this.$message.error("Error al actualizar");
        });
    },
    async NominaDeclined(NominaId) {
      const params = {
        status: 0,
        NominaId: NominaId
      };
      await this.$http
        .put("/api/Payroll/declinestatusnomina", params)
        .then(() => {
          this.$message.success("Estatus actualizado");
          this.nominaStatusApproved = 1;
        })
        .catch(() => {
          this.$message.error("Error al actualizar");
        });
    },
    async ManageDeclinedNomina(NominaId) {
      this.$confirm("Segura/o que desea rechazar esta nomina ?")
        .then(async () => {
          await this.NominaDeclined(NominaId);
        })
        .catch(() => {
          this.$message.info("Rechazo de nomina cancelado");
        });
    },
    async GenerateTxtFile(NominaId, from = "BHD") {
      let companyName = this.companySelectedName();
      let companyRNC = this.companySelectedRNC();
      const body = {
        params: {
          nominaid: NominaId,
          From: from,
          CompanyRNC: companyRNC,
          CompanyName: companyName
        }
      };
      await this.$http
        .get("/api/payroll/textfile/bhd", body, {
          responseType: "blob"
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"]
          });
          // Create a link element
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // Set the file name
          link.download = `${this.NominaName}_${companyName}_${from}.txt`;
          // Append the link to the body
          document.body.appendChild(link);
          // Programmatically click the link to trigger the download
          link.click();
          // Remove the link from the DOM
          document.body.removeChild(link);
        })
        .catch((ex) => {
          this.$message.error(ex.response.data);
        });
    },
    ontabClick() {
      switch (this.TabName) {
        case "Nomina": {
          this.GetNominaReport();
          this.EmployeeSelected = 0;
          break;
        }
        case "History": {
          this.GetNominaReport();
          this.EmployeeSelected = 0;
          break;
        }
        case "incomeHistoric": {
          this.GetIncomeData();
          this.EmployeeSelected = 0;
          break;
        }
        case "discountHistoric": {
          this.GetDiscountData();
          this.EmployeeSelected = 0;
          break;
        }
      }
    },
    rechargeIncomeDiscountData(nomina = null) {
      if (nomina === null) {
        this.RecalculatePayrollExternal();
      } else {
        this.RecalculateNomina(nomina);
      }

      //this.$refs.NominaHistoric.GetNominaItems();
      this.GetNominaReport();

      this.MasiveIncomeVisible = false;
      this.MasivediscountVisible = false;
      this.GetIncomeData();
      this.GetDiscountData();
    },
    OnDirectionSelected(direction) {
      this.DirectionSelected = direction;
    },
    OnEmployeeSelected(employee) {
      this.EmployeeSelected = employee;
    },
    OnIcomesEmployeeSelected(employee) {
      this.EmployeeSelected = employee;
    },
    OnDiscountsEmployeeSelected(employee) {
      this.EmployeeSelected = employee;
    },
    DeleteIncome(income) {
      const body = {
        params: {
          Id: income.Id
        }
      };

      this.$http.delete("/api/payroll/DeleteIncome", body).then(() => {
        this.GetIncomeData();

        this.RecalculatePayrollExternal();
      });
    },
    DeleteDiscount(discount) {
      const body = {
        params: {
          Id: discount.Id
        }
      };

      this.$http.delete("/api/payroll/DeleteDiscounts", body).then(() => {
        this.GetDiscountData();
        this.RecalculatePayrollExternal();
      });
    },
    async RecalculatePayrollExternal() {
      let body = {};
      await this.$http
        .put("/api/Payroll/RecalcularNominaDesdeFuera", body)
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    async exportToExcel() {
      this.CalculateSumariesBeforeExportingToExcel(this.nominaData);
      let company = this.companySelectedName();
      let paymentFormLabel = this.paymentForms.filter(
        (pf) => pf.value === this.paymentForm
      )[0].label;

      let columnNames = [
        "Codigo",
        "Nombre y Apellido",
        "Cedula",
        "Cuenta",
        "Departamento",
        "Cargo",
        "Dias",
        "Salario Mensual",
        "Salario Quincenal",
        "Días Trabajados",
        "Monto Trabajado",
        "Comision",
        "Otros",
        "Incentivos",
        "Prima Vacacional",
        "Salario Retroactivo",
        "Total Ingresos",
        "AFP",
        "SFS",
        "PERCAPITA",
        "SEGURO PRIVADO",
        "ISR",
        "CXC",
        "Otros",
        "Descuentos Especiales",
        "Total Descuentos",
        "Neto a pagar"
      ];
      let columnsData = [];

      this.Directions.forEach((dir) => {
        columnsData.push([dir.Name]);
        columnsData = columnsData.concat(
          this.nominaData
            .filter((nom) => nom.Empleado.Direccion.Id === dir.Id)
            .map((item) => {
              return [
                item.Empleado.ID,
                item.Empleado.Nombre,
                FormatCedula(item.Empleado.Cedula),
                item.Empleado.cuenta,
                item.Empleado.Deparmento.Name,
                item.Empleado.Posicion.Name,
                item.Days,
                Number(item.Empleado.Salario),
                Number(item.SalarioQuincenal),
                Number(item.diasTrabajados),
                Number(item.MontoTrabajado),
                Number(item.Comision),
                Number(item.OtrosIngresos),
                Number(item.Incetivos),
                Number(item.Vacaciones),
                Number(item.SalarioRetroactivo),
                Number(item.total_income),
                Number(item.Total_AFP),
                Number(item.Total_SFS),
                Number(item.PERCAPITA),
                Number(item.PrivateInsurance),
                Number(item.ISR_COBRADO),
                Number(item.CXC),
                Number(item.OtrosDescuentos),
                Number(item.DESCUENTOS_ESPECIALES),
                Number(item.total_discount),
                Number(item.TOTAL_A_PAGAR)
              ];
            })
        );
        //columnsData.push([])
        columnsData.push(
          this.CalculateSumariesByDirectionsBeforeExportingToExcel(
            this.nominaData.filter(
              (nom) => nom.Empleado.Direccion.Id === dir.Id
            )
          )
        );
        columnsData.push([]);
      });

      let fileTitle = this.NominaName;

      await exportNominaToExcel(
        columnNames,
        columnsData,
        fileTitle,
        paymentFormLabel,
        this.arrayOfSummariesToExport,
        company
      );
    },
    CalculateSumariesBeforeExportingToExcel(nominaData) {
      this.arrayOfSummariesToExport = ["", "", "", "", "", "", ""];
      this.arrayOfNominasProps.forEach((prop) => {
        if (prop === "Salario") {
          //Empleado.Salario
          this.arrayOfSummariesToExport.push(
            Number(
              nominaData.reduce((acc, curr) => acc + curr.Empleado[prop], 0)
            )
          );
        } else {
          this.arrayOfSummariesToExport.push(
            Number(nominaData.reduce((acc, curr) => acc + curr[prop], 0))
          );
        }
      });
    },
    CalculateSumariesByDirectionsBeforeExportingToExcel(nominaData) {
      let arrayOfSummariesToExport = ["", "", "", "", "", "", ""];
      this.arrayOfNominasProps.forEach((prop) => {
        if (prop === "Salario") {
          //Empleado.Salario
          arrayOfSummariesToExport.push(
            Number(
              nominaData.reduce((acc, curr) => acc + curr.Empleado[prop], 0)
            )
          );
        } else {
          arrayOfSummariesToExport.push(
            Number(nominaData.reduce((acc, curr) => acc + curr[prop], 0))
          );
        }
      });
      return arrayOfSummariesToExport;
    },
    companySelectedName() {
      let companySelectedName = this.companySelected.filter(
        (company) => company.value === this.companyId
      )[0].label;
      return companySelectedName;
    },
    companySelectedRNC() {
      let companySelectedRNC = this.companySelected.filter(
        (company) => company.value === this.companyId
      )[0].rnc;
      return companySelectedRNC;
    },
    async SendPaymentSlip() {
      let companyName = this.companySelectedName();
      let companyRNC = this.companySelectedRNC();
      const body = {
        NominaId: this.nominaId,
        Company: this.companyId,
        CompanyName: companyName,
        CompanyRNC: companyRNC
      };
      await this.$http
        .post("/api/Payroll/SendPaymentReceipt", body)
        .then((/*response*/) => {
          //console.log(response)
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onDirectionDataLoad(directions) {
      this.Directions = directions;
    }
  },
  watch: {
    labelApprovalStatus(newValue) {
      this.NominaStatusName = newValue;
    }
  }
};
</script>

<style scoped></style>
